module.exports = __webpack_public_path__ + "img/kj2.cdcb57a9.png";